export const calculatePaginationRangeForCursorBasedPagination = ({
  cursorHistoryLength,
  pageSize,
  currentItemsCount,
  totalItems,
}: {
  cursorHistoryLength: number;
  pageSize: number;
  currentItemsCount: number;
  totalItems: number;
}) => {
  const currentPage = cursorHistoryLength + 1;
  const startIndexOfPage = (currentPage - 1) * pageSize + 1;
  const endIndexOfPage = Math.min(
    startIndexOfPage + currentItemsCount - 1,
    totalItems
  );

  return {
    startIndexOfPage,
    endIndexOfPage,
    totalItemsForPage: totalItems,
  };
};
